import { IonButton, IonLabel } from '@ionic/react'
import React, { BaseSyntheticEvent, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import BadgeComponent, { IBadge } from '../badge/Badge.component'
import { IButton } from '../button/Button.component'
import './Timer.component.css'

export interface ITimer extends IButton, IBadge {
  startTime: { hours: number; minutes: number; seconds: number }
  savedTime?: number
  timerDirection: 'up' | 'down'
  showCount?: boolean
  showFlash?: boolean
  flashColor?: string
  flashTimes?: [{ hours: string; minutes: string; seconds: string }]
  disabled?: boolean
  maxTimes?: number
  buttonId?: number | string
}
const Timer: React.FC<ITimer> = (props: ITimer) => {
  const {
    startTime,
    savedTime,
    timerDirection,
    showCount,
    count,
    color,
    size,
    fill,
    expand,
    showFlash,
    flashColor,
    flashTimes,
    action,
    disabled,
    maxTimes,
    buttonId,
  } = props

  const dispatch = useDispatch()
  const [flash, setFlash] = useState(false)
  const [timerHours, setHours] = useState('')
  const [timerMinutes, setMinutes] = useState('00')
  const [timerSeconds, setSeconds] = useState('00')
  const [reset, setReset] = useState(false)
  const duration = timerDirection === 'up' ? 5 * 60 * 60 * 1000 : 1000
  let timer: number | undefined = undefined
  let timerStartTime: number
  let interval: any = null

  const msToTime = (remaining?: number) => {
    // @ts-ignore
    let diff = Date.now() - savedTime
    if (remaining) {
      diff = remaining
    }
    const hours: number | string =
      Math.floor((diff / (1000 * 60 * 60)) % 24) === 0
        ? ''
        : Math.floor((diff / (1000 * 60 * 60)) % 24).toString() + ':'
    const minutes =
      Math.floor((diff / (1000 * 60)) % 60) < 10
        ? '0' + Math.floor((diff / (1000 * 60)) % 60).toString()
        : Math.floor((diff / (1000 * 60)) % 60).toString()
    const seconds =
      Math.floor((diff / 1000) % 60) < 10
        ? '0' + Math.floor((diff / 1000) % 60).toString()
        : Math.floor((diff / 1000) % 60).toString()
    setHours(hours)
    setMinutes(minutes)
    setSeconds(seconds)

    if (showFlash && flashTimes) {
      for (let i = 0; i < flashTimes.length; i++) {
        const flashTime = flashTimes[i]
        if (hours === flashTime.hours && minutes === flashTime.minutes && seconds === flashTime.seconds) {
          setFlash(true)
        }
        if (hours >= flashTime.hours && minutes >= flashTime.minutes && seconds >= flashTime.seconds) {
          setFlash(true)
        }
      }
    }
  }

  const startTimer = () => {
    timer = undefined
    if (!timer) {
      if (savedTime) {
        timerStartTime =
          timerDirection === 'up'
            ? savedTime
            : savedTime + startTime.hours * (60000 * 60) + startTime.minutes * 60000 + startTime.seconds * 1000
      } else {
        timerStartTime =
          Date.now() + startTime.hours * (60000 * 60) + startTime.minutes * 60000 + startTime.seconds * 1000
      }
      interval = window.setInterval(() => {
        timerDirection === 'up' ? msToTime() : run()
      }, 10)
    }
  }

  useEffect(() => {
    setFlash(false)
    if (count > 1) {
      setReset(true)
      setHours('')
      setMinutes('00')
      setSeconds('00')
      startTimer()
    } else if (!reset && count != 0 && maxTimes != count) {
      startTimer()
    }
    return () => {
      clearInterval(interval)
    }
  }, [count])

  const run = () => {
    const diff = Date.now() - timerStartTime
    let remaining = duration - diff

    if (remaining < 0) {
      remaining = 0
    }

    if (timerDirection === 'up') {
      msToTime(diff)
    } else {
      msToTime(remaining)
    }

    if (remaining === 0) {
      window.clearTimeout(timer)
      timer = undefined
    }
  }

  const clickAction = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    if (action) {
      dispatch({ type: action, payload: buttonId })
    }
  }

  return (
    <>
      <IonButton
        tabIndex={-1}
        data-testid={`ButtonTimer${buttonId}`}
        disabled={disabled}
        class='count-timer'
        onClick={clickAction}
        color={flash ? flashColor : color}
        size={size ? size : 'default'}
        fill={fill ? fill : 'solid'}
        expand={expand ? expand : 'block'}>
        <IonLabel>{`${timerHours}${timerMinutes}:${timerSeconds}`}</IonLabel>
        {showCount && <BadgeComponent count={count} color='white' testId={buttonId} />}
      </IonButton>
    </>
  )
}

export default Timer
